<header class="mobile-page-header" [class.fixed-header]="fixed">
  @if (showBack) {
    <button
      type="button"
      class="mobile-page-back-btn"
      (click)="back.emit()"
      [attr.aria-label]="backLabel"
    >
      <img src="/static_images/ic_back.svg" alt="" />
    </button>
  }

  <h1 class="mobile-page-title">{{ title }}</h1>
</header>
